import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import reportWebVitals from './reportWebVitals';

import './index.css';

import { BrowserRouter } from 'react-router-dom';
import { RoutableAuth0Provider } from './RoutableAuth0Provider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <RoutableAuth0Provider
        domain="dev-v1ilcf86.us.auth0.com"
        clientId="lqMbTkimkStNCMot9MZxgr3bsljSEoGx"
        redirectUri={window.location.origin}
        cacheLocation="localstorage"
        audience={process.env.REACT_APP_AUTH0_AUDIENCE}
      >
        <Suspense fallback={'App loading...'}>
          <App />
        </Suspense>
      </RoutableAuth0Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
